import YoutubePlayer from 'yt-player';


let multiVideoPlayer = () => {

    let module = {},
        popup,
        popupClose,
        popupBody,
        body,
        page,
        main,
        multiytVideo,
        createMultiVideoPopup = () => {
            if (!popup.length) {
                return;
            }
			
            popup.show();

			
            setTimeout(function() {
                body.addClass('overflow-hidden');
                popup.addClass('active');
				
				if (!window.YT) {
					$("body").append('<div id="x-player" style="display:none"></div>');
					new YoutubePlayer("#x-player");
					$("#x-player").remove();
				}
				
                var checkReady = setInterval(function() {
					//console.log("init yt");
					if (!window.YT) { return; }
					clearInterval(checkReady);
					setTimeout(function() {
						createMultiYTVideo();
						//console.log("create "+videoId);
					}, 500);
				}, 500);
				
            }, 50);
        },
        createMultiYTVideo = () => {
            if (!popupBody.length) {
                return;
            }
            popupBody.each(function () {
				
				var overlay_content = $(".multivideo_overlay").clone();
				overlay_content.removeClass("multivideo_overlay").addClass("multivideo");
				$(this).html("").append(overlay_content);
				
				var videoId = $(this).find(".multivideo .menu a").eq(0).attr("data-video-id");
				$(this).find(".multivideo .menu a").eq(0).addClass("active").addClass("playing");
				
				$(this).find(".video-holder").html('<div id="multivideo-wrap"></div>');
				
				//console.log("init2");
				window.multiytVideo = new YoutubePlayer('#multivideo-wrap', {
					controls: 1,
					info: 0,
					related: 0,
					annotations: 0,
					captions: 0,
					modestBranding: 1,
					loop: 1,
					showinfo:0,
					playerVars: {
						rel: 0,
						showinfo: 0,
						ecver: 2
					}
				});

				window.multiytVideo.load(videoId);

				const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

				if (iOS) {
					//window.multiytVideo.mute();
				}


				if (! iOS) {
//					window.multiytVideo.mute();
					window.multiytVideo.play();
				}

				window.multiytVideo.on('ended', () => {
					window.multiytVideo.play();
				});

				$(this).find(".multivideo .menu a").click(function() {
					if ($(this).hasClass("playing")) {
						$(this).removeClass("playing");
						window.multiytVideo.pause();
					} else {
						if ($(this).hasClass("active")) {
							window.multiytVideo.play();
							$(this).addClass("playing");
						} else {
							$(".multivideo .menu a").removeClass("active").removeClass("playing");
							$(this).addClass("active").addClass("playing");
							window.multiytVideo.load($(this).attr("data-video-id"));
							window.multiytVideo.play();
						}
					}
					return false;
				});

				return multiytVideo;



            });
        },
        destroyYtVideo = () => {
            //multiytVideo.stopVideo();
			if (typeof window.multiytVideo !== 'undefined') {
				window.multiytVideo.destroy();
			}
        },
        onPlayButtonClick = () => {
            // if 360 video on iOS, redirect to youtube
            const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

            $('[data-yt-video-popup-id]').on('click', function (event) {
                event.preventDefault();
                var $this = $(this);
                var videoId = $this.attr('data-yt-video-popup-id');
                if(!videoId) {
                    return;
                }

                if (iOS && $(this).hasClass('video-360')) {
                    window.location = 'https://www.youtube.com/watch?v='+ videoId +'&autoplay=1';
                    // window.location = 'youtube://'+ videoId;
                    return;
                }

                createMultiVideoPopup();
            });
        },
        onCloseButtonClick = () => {
            if (!popupClose.length) {
                return;
            }
            popupClose.on('click', function () {
                body.removeClass('overflow-hidden');
                destroyYtVideo();
                popup.removeClass('active');
				popupBody.html("");
                setTimeout(function() {
                    popup.hide();
                }, 200);
            });
        },
        init = () => {
            popup = $('.yt-video-popup');
            popupClose = $('.yt-video-popup-close');
            popupBody = $('.yt-video-popup-body');
			popupBody.addClass("multivideo");
            body = $('html,body');
            //onPlayButtonClick();
            onCloseButtonClick();
            //console.log('yt-video-popup');

        };

    module.init = init;
	module.exports = {
	  run: function () {
		  init();
		  createMultiVideoPopup();
	  }
	};
    return module;

};
window.multiVideoPlayer = multiVideoPlayer();
export default multiVideoPlayer();